import { assign } from '../../shared/Assign';
import * as ActionTypes from './AgreementsActionTypes';
import InitialState from './AgreementsInitialState';

export default function agreementReducer(
    state: any = InitialState.agreements,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case ActionTypes.LOAD_AGREEMENTS_SUCCESS: {
            const newState = assign({}, state);
            newState.list = action.result;
            return newState;
        }

        case ActionTypes.NEW_AGREEMENT_SUCCESS: {
            const newState = assign({}, state);
            newState.modal.productTypes = action.result;
            return newState;
        }

        case ActionTypes.CREATE_AGREEMENT_SUCCESS: {
            const newState = assign({}, state);
            newState.list = [...newState.list, assign({}, action.result)];
            return newState;
        }

        case ActionTypes.EDIT_AGREEMENT_SUCCESS: {
            const newState = assign({}, state);
            newState.modal.productTypes = action.result.productTypes;
            newState.edit.agreement = action.result.agreement;
            return newState;
        }

        case ActionTypes.UPDATE_AGREEMENT_SUCCESS: {
            const newState = assign({}, state);
            newState.list = [
                ...state.list.filter((x: any) => x.id !== action.result.id),
                assign({}, action.result)
            ];
            return newState;
        }

        case ActionTypes.DELETE_AGREEMENT_SUCCESS: {
            const newState = assign({}, state);
            newState.list = [...state.list.filter((x: any) => x.id !== action.result)];
            return newState;
        }

        case ActionTypes.CHECK_DELETE_AGREEMENT_SUCCESS: {
            const newState = assign({}, state);
            newState.deleteAgreementPhotographers = action.result;
            return newState;
        }

        case ActionTypes.UPDATE_PHOTOGRAPHER_AGREEMENT_SUCCESS:
            return {
                ...state,
                deleteAgreementPhotographers: state.deleteAgreementPhotographers.map(
                    (photographer) => {
                        if (photographer.id === action.result.photographerId) {
                            return {
                                ...photographer,
                                agreementId: action.result.agreementId
                            };
                        }

                        return photographer;
                    }
                )
            };
        default:
            return state;
    }
}
